"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MetaApiLimiterGuard", {
    enumerable: true,
    get: function() {
        return MetaApiLimiterGuard;
    }
});
const _common = require("@nestjs/common");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let MetaApiLimiterGuard = class MetaApiLimiterGuard {
    async canActivate(_context) {
        return true;
    }
};
MetaApiLimiterGuard = _ts_decorate([
    (0, _common.Injectable)()
], MetaApiLimiterGuard);
